import React from 'react';
import PropTypes from 'prop-types';
import ButtonSecondary from '../../elems/ButtonSecondary';
// import ButtonSecondary from './ButtonSecondaryNew';
import { FormattedMessage } from 'react-intl';

const PricingCard3 = ({ users, plan }) => {

  return (
    <div className="w-24 pricing_item text-center py-3 px-2 bg-white br-6">
      <p className="fs2_5 bold">
        <FormattedMessage
          id="admin.pricing.card.title3"
          defaultMessage="Enterprise"
        />
      </p>
      <p className="fs2 blue my-1">
        <FormattedMessage
          id="admin.pricing.card.price3"
          defaultMessage="Custom pricing"
        />
      </p>
      <p className="small mb-xs">
       <b>{users}+</b>{' '}
        <FormattedMessage
          id="admin.pricing.card.users"
          defaultMessage="users"
        />
        </p>
      <p className="small mb-xs">
        <b><FormattedMessage
          id="admin.pricing.card.everything"
          defaultMessage="Everything in Pro, plus"
        /></b>
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.sso"
          defaultMessage="Single sign-on (SSO)"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.priority"
          defaultMessage="Priority service"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.integrations"
          defaultMessage="Custom integrations"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.onboarding"
          defaultMessage="Onboarding"
        />
      </p>
      <p className="small mb-2">
        <FormattedMessage
          id="admin.pricing.card.training"
          defaultMessage="Training"
        />
      </p>

      <ButtonSecondary plan={plan} btn={33} link={true} url={`mailto:${process.env.REACT_APP_EMAIL}?subject=Enterprise pricing request`} externalLink={1} />
    </div>
  );
};

PricingCard3.propTypes = {
  users: PropTypes.number.isRequired
};

export default PricingCard3;
